(function () {
  // Build sidebar links from the rendered accordion groups
  function buildSidebarLinks() {
    const sidebarLinksParent = document.getElementById("sidebar-links-parent");
    if (!sidebarLinksParent) return;

    if (
      sidebarLinksParent.querySelector(".faq-sidebar-link, #faq-sidebar-select")
    )
      return;

    const groups = document.querySelectorAll("[data-faq-group]");
    groups.forEach((group) => {
      const title = group.getAttribute("data-faq-title") || "Untitled";
      const id = group.id;
      if (!id) return;

      const a = document.createElement("a");
      a.href = `#${id}`;
      a.textContent = title;
      a.className =
        "faq-sidebar-link block hover:font-bold no-underline text-[20px]";
      sidebarLinksParent.appendChild(a);
    });
  }

  // Your existing responsive behavior, now calling buildSidebarLinks() first
  const screenObserver = new ResizeObserver((entries) => {
    const entry = entries[0];
    if (!entry) return;

    const { width } = entry.contentRect;

    const sidebarSection = document.getElementById("faq-sidebar-parent");
    const sidebarLinksParent = document.getElementById("sidebar-links-parent");
    if (!sidebarSection || !sidebarLinksParent) return;

    // Ensure links exist before we transform them
    buildSidebarLinks();

    const anchors = sidebarLinksParent.querySelectorAll(".faq-sidebar-link");
    const hasSelect = !!sidebarLinksParent.querySelector("#faq-sidebar-select");

    // Mobile: turn links into a <select>
    if (width < 1024 && anchors.length > 0 && !hasSelect) {
      const textTargets = Array.from(anchors).map((a) => ({
        text: a.textContent.trim(),
        target: a.getAttribute("href").split("#").at(-1),
      }));

      anchors.forEach((a) => a.remove());

      const select = document.createElement("select");
      select.id = "faq-sidebar-select";
      select.style.backgroundColor = "inherit";
      select.style.width = "100%";
      select.style.borderRadius = "10px";
      select.style.fontSize = "20px";
      select.style.fontFamily = "inherit";

      const topOption = document.createElement("option");
      topOption.textContent = "Jump to section";
      topOption.style.fontSize = "20px";
      topOption.style.fontFamily = "inherit";
      select.append(topOption);

      textTargets.forEach((tt, idx) => {
        const option = document.createElement("option");
        option.id = "faq-sidebar-link-" + idx;
        option.value = `#${tt.target}`;
        option.textContent = tt.text;
        option.style.fontSize = "20px";
        option.style.fontFamily = "inherit";
        select.append(option);
      });

      select.addEventListener("change", (event) => {
        const targetId = event.target.value;
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });

      sidebarLinksParent.append(select);

      // Desktop: swap the select back into links
    } else if (width >= 1024 && hasSelect) {
      const select = sidebarLinksParent.querySelector("#faq-sidebar-select");
      const options = Array.from(select.children);
      const textTargets = options
        .filter((opt) => opt.value && opt.value.startsWith("#"))
        .map((op) => ({ text: op.textContent, target: op.value }));

      select.remove();

      textTargets.forEach((tt) => {
        const anchor = document.createElement("a");
        anchor.className = "faq-sidebar-link mt-4 block font-bold no-underline";
        anchor.href = tt.target;
        anchor.textContent = tt.text;
        sidebarLinksParent.append(anchor);
      });
    }
  });

  // Kick everything off once DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    // Build links once on load (in case observer fires late)
    buildSidebarLinks();
    // Start observing viewport width changes
    screenObserver.observe(document.body);
  });
})();
